import { render, staticRenderFns } from "./natResourceAddedLicense.vue?vue&type=template&id=3fb8dc06"
import script from "./natResourceAddedLicense.vue?vue&type=script&lang=js"
export * from "./natResourceAddedLicense.vue?vue&type=script&lang=js"
import style0 from "./natResourceAddedLicense.vue?vue&type=style&index=0&id=3fb8dc06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports